webpackJsonp([6,4],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _index = __webpack_require__(425);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _lib = __webpack_require__(423);
	
	var _lib2 = _interopRequireDefault(_lib);
	
	__webpack_require__(159);
	
	__webpack_require__(194);
	
	var _vue = __webpack_require__(56);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(157);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(505);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _en = __webpack_require__(424);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _App = __webpack_require__(466);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _store = __webpack_require__(163);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(161);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.use(_lib2.default, { locale: _en2.default });
	
	new _vue2.default({
	  router: _router2.default,
	  store: _store2.default,
	  components: {
	    App: _App2.default
	  },
	  template: '<App/>'
	}).$mount('#app');

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUserConfig = getUserConfig;
	exports.getUser = getUser;
	exports.onAuthChange = onAuthChange;
	exports.signInWithEmail = signInWithEmail;
	exports.signInAnonymously = signInAnonymously;
	exports.signInWithGoogle = signInWithGoogle;
	exports.signOut = signOut;
	exports.getCurrentUser = getCurrentUser;
	exports.getCredentail = getCredentail;
	exports.sendPasswordResetEmail = sendPasswordResetEmail;
	
	var _vue = __webpack_require__(56);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _firebase = __webpack_require__(13);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getUserConfig(env, username) {
	  var domain = 'https://qx0nowybrl.execute-api.us-east-1.amazonaws.com';
	  var path = env + '/getConfiguration';
	  var url = domain + '/' + path;
	  var params = {
	    username: encodeURIComponent(username)
	  };
	  return _vue2.default.http.get(url, { params: params });
	}
	
	function getUser() {
	  return _firebase2.default.auth().currentUser;
	}
	
	function onAuthChange(callback) {
	  return _firebase2.default.auth().onAuthStateChanged(callback);
	}
	
	function signInWithEmail(username, password) {
	  return _firebase2.default.auth().signInWithEmailAndPassword(username, password);
	}
	
	function signInAnonymously() {
	  return _firebase2.default.auth().signInAnonymously();
	}
	function signInWithGoogle() {
	  var provider = new _firebase2.default.auth.GoogleAuthProvider();
	  provider.setCustomParameters({ hd: 'impactanalytics.co' });
	  return _firebase2.default.auth().signInWithPopup(provider);
	}
	
	function signOut() {
	  return _firebase2.default.auth().signOut();
	}
	
	function getCurrentUser() {
	  return _firebase2.default.auth().currentUser;
	}
	
	function getCredentail(email, password) {
	  return _firebase2.default.auth.EmailAuthProvider.credential(email, password);
	}
	
	function sendPasswordResetEmail(email) {
	  return _firebase2.default.auth().sendPasswordResetEmail(email);
	}

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function getEnvAndClient() {
	  var host = location.host;
	  var urlParts = host.split('.');
	  var isDev = window.location.href.indexOf('localhost');
	
	  var env = 'dev';
	  var client = isDev > 0 ? 'devuser' : urlParts[0];
	  return { env: env, client: client };
	}
	
	function getConfig() {
	  var _getEnvAndClient = getEnvAndClient(),
	      env = _getEnvAndClient.env,
	      client = _getEnvAndClient.client;
	
	  var config = JSON.parse(localStorage.getItem(env));
	  var clientConfig = JSON.parse(localStorage.getItem(client));
	  return { config: config, env: env, client: client, clientConfig: clientConfig };
	}
	
	function saveConfig(env, config) {
	  localStorage.setItem(env, JSON.stringify(config));
	}
	
	function clearConfig(env) {
	  localStorage.removeItem(env);
	  localStorage.removeItem('firebase_email_id');
	  if (localStorage.getItem('is_anonymous_login')) localStorage.removeItem('is_anonymous_login');
	}
	
	function normalizeConfig(config) {
	  var companyConfig = config.company_configuration;
	  var webConfig = companyConfig && companyConfig.web;
	  return webConfig;
	}
	
	exports.getConfig = getConfig;
	exports.saveConfig = saveConfig;
	exports.clearConfig = clearConfig;
	exports.normalizeConfig = normalizeConfig;

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialise = initialise;
	exports.deleteApp = deleteApp;
	
	var _firebase = __webpack_require__(13);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _vue = __webpack_require__(56);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuefire = __webpack_require__(507);
	
	var _vuefire2 = _interopRequireDefault(_vuefire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function initialise(config) {
	  _firebase2.default.initializeApp(config);
	  _vue2.default.use(_vuefire2.default);
	}
	
	function deleteApp() {
	  var app = _firebase2.default.app();
	  return app.delete();
	}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = errorCodeToMessage;
	
	var _firebase = __webpack_require__(160);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function humanize(errorCode) {
	  return _firebase2.default[errorCode];
	}
	
	function errorCodeToMessage(error) {
	  if (typeof error === 'string') {
	    return humanize(error);
	  }
	  var errorCode = void 0;
	  if (error.code) {
	    errorCode = error.code;
	  } else {
	    errorCode = error.body.Error;
	  }
	  console.log(errorCode);
	  return humanize(errorCode);
	}

/***/ }),

/***/ 160:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ERRORS = {
	  'auth/invalid-email': 'Invalid email address.',
	  'auth/user-disabled': 'Your profile is disabled. Please mail to insideinsight.co for furthur details.',
	  'auth/user-not-found': 'Email/Username not found.',
	  'auth/wrong-password': 'Wrong password.',
	  'auth/weak-password': 'Password should be at least 6 characters',
	  'auth/operation-not-allowed': 'Please contact support for Guest Sign In access',
	  'Username is not found': 'Please check the url and try Sign In. Happening again? Contact support.'
	};
	
	exports.default = ERRORS;

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vueRouter = __webpack_require__(157);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(162);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = new _vueRouter2.default({ routes: _routes2.default });
	
	router.beforeEach(function (to, from, next) {
	  if (!localStorage.getItem('uid') && to.params.id) {
	    localStorage.setItem('directSurveyId', to.params.id);
	  }
	  if (to.name !== 'Login' && !localStorage.getItem('uid')) {
	    next({ name: 'Login' });
	  } else if (to.name === 'Login' && localStorage.getItem('uid')) {
	    if (localStorage.getItem('directSurveyId')) {
	      next('/' + localStorage.getItem('directSurveyId'));
	    } else {
	      next('/home');
	    }
	  } else {
	    next();
	  }
	});
	
	exports.default = router;

/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Login = __webpack_require__(472);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Layout = __webpack_require__(470);
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Home = function Home(resolve) {
	  __webpack_require__.e/* nsure */(1, function () {
	    resolve(__webpack_require__(141));
	  });
	};
	
	var Survey = function Survey(resolve) {
	  __webpack_require__.e/* nsure */(0, function () {
	    resolve(__webpack_require__(155));
	  });
	};
	
	var ResetPassword = function ResetPassword(resolve) {
	  __webpack_require__.e/* nsure */(2, function () {
	    resolve(__webpack_require__(140));
	  });
	};
	
	var ThankUser = function ThankUser(resolve) {
	  __webpack_require__.e/* nsure */(3, function () {
	    resolve(__webpack_require__(156));
	  });
	};
	
	var routes = [{ path: '/',
	  component: _Login2.default,
	  name: 'Login',
	  children: [{ path: '/:username/:password', component: _Login2.default }]
	}, { path: '/home',
	  component: _Layout2.default,
	  children: [{ path: '/', component: Home }, { path: '/:id', component: Survey }, { path: 'user/resetPassword', component: ResetPassword }, { path: 'user/thankuser', component: ThankUser }]
	}];
	
	exports.default = routes;

/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(56);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(36);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _appGlobal = __webpack_require__(164);
	
	var _appGlobal2 = _interopRequireDefault(_appGlobal);
	
	var _authentication = __webpack_require__(165);
	
	var _authentication2 = _interopRequireDefault(_authentication);
	
	var _user = __webpack_require__(166);
	
	var _user2 = _interopRequireDefault(_user);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = new _vuex2.default.Store({
	  modules: {
	    appGlobal: _appGlobal2.default,
	    authentication: _authentication2.default,
	    user: _user2.default
	  }
	});
	
	exports.default = store;

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _authentication = __webpack_require__(57);
	
	var _config = __webpack_require__(72);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var appGlobal = {
	  state: {
	    clientConfig: {},
	    env: '',
	    firebaseEmail: '',
	    locale: 'en',
	    config: {},
	    user: null
	  },
	
	  getters: {
	    env: function env(state) {
	      return state.env;
	    },
	    config: function config(state) {
	      return state.config;
	    }
	  },
	
	  mutations: {
	    SET_LOCALE: function SET_LOCALE(state, locale) {
	      state.locale = locale;
	    },
	    SET_ENV: function SET_ENV(state, payload) {
	      state.env = payload;
	    },
	    SET_CLIENT_CONFIG: function SET_CLIENT_CONFIG(state, clientConfig) {
	      state.clientConfig = clientConfig;
	    },
	    SET_CLIENT: function SET_CLIENT(state, client) {
	      state.client = client;
	    },
	    SET_FIREBASE_EMAIL: function SET_FIREBASE_EMAIL(state, payload) {
	      state.firebaseEmail = payload;
	    },
	    SET_CONFIG: function SET_CONFIG(state, payload) {
	      state.config = payload;
	    },
	    SAVE_USER: function SAVE_USER(state, payload) {
	      state.user = payload;
	    }
	  },
	
	  actions: {
	    getConfigFromLS: function getConfigFromLS(_ref) {
	      var commit = _ref.commit;
	
	      var _getConfig = (0, _config.getConfig)(),
	          config = _getConfig.config,
	          client = _getConfig.client,
	          env = _getConfig.env,
	          clientConfig = _getConfig.clientConfig;
	
	      commit('SET_ENV', env);
	      commit('SET_CLIENT_CONFIG', clientConfig);
	      commit('SET_CLIENT', client);
	      commit('SET_CONFIG', config);
	    },
	    getClientConfig: function getClientConfig(_ref2) {
	      var _this = this;
	
	      var state = _ref2.state,
	          commit = _ref2.commit;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var config;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _authentication.getUserConfig)(state.env, state.client);
	
	              case 2:
	                config = _context.sent;
	
	                localStorage.setItem(state.client, JSON.stringify(config.data));
	                commit('SET_CLIENT_CONFIG', config.data, state.client);
	
	              case 5:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    }
	  }
	};
	
	exports.default = appGlobal;

/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _firebase = __webpack_require__(13);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _authentication = __webpack_require__(57);
	
	var _firebase3 = __webpack_require__(104);
	
	var _firebase4 = _interopRequireDefault(_firebase3);
	
	var _config = __webpack_require__(72);
	
	var _firebase5 = __webpack_require__(102);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var storageDb = _firebase2.default.initializeApp({
	  apiKey: 'AIzaSyAzQEBjw9rul7LW14kt_wJlG2QbOJuBydY',
	  authDomain: 'storage-7ecd6.firebaseapp.com',
	  databaseURL: 'https://storage-7ecd6.firebaseio.com',
	  projectId: 'storage-7ecd6',
	  storageBucket: 'storage-7ecd6.appspot.com',
	  messagingSenderId: '73859705508'
	}, 'STORAGE');
	
	var authentication = {
	  state: {
	    message: '',
	    logos: [],
	    messageType: 'error',
	    isAuthRequested: false,
	    isAuthenticated: false,
	    isAuthenticating: false,
	    isAuthFailed: false,
	    isAnonymousAuthenticating: false,
	    sendingPasswordResetLink: false,
	    getConfigUrl: 'https://qx0nowybrl.execute-api.us-east-1.amazonaws.com/development/getConfiguration'
	  },
	
	  getters: {
	    authenticated: function authenticated(state) {
	      return state.isAuthenticated;
	    },
	    authRequested: function authRequested(state) {
	      return state.isAuthRequested;
	    },
	    authFailed: function authFailed(state) {
	      return state.isAuthFailed;
	    }
	  },
	
	  mutations: {
	    IS_AUTHENTICATING: function IS_AUTHENTICATING(state, payload) {
	      state.isAuthenticating = payload;
	    },
	    IS_ANONYMOUS_AUTHENTICATING: function IS_ANONYMOUS_AUTHENTICATING(state, payload) {
	      state.isAnonymousAuthenticating = payload;
	    },
	    AUTH_REQUESTED: function AUTH_REQUESTED(state) {
	      state.isAuthRequested = true;
	    },
	    AUTH_SUCCESS: function AUTH_SUCCESS(state) {
	      state.isAuthenticated = true;
	      state.isAuthenticating = false;
	      state.isAnonymousAuthenticating = false;
	    },
	    AUTH_FAILED: function AUTH_FAILED(state, payload) {
	      var errorMessage = (0, _firebase4.default)(payload);
	      if (!errorMessage) errorMessage = 'User not found.';
	      state.message = errorMessage;
	      state.isAuthFailed = true;
	      state.isAuthenticating = false;
	    },
	    CLEAR_MESSAGE: function CLEAR_MESSAGE(state) {
	      state.message = '';
	      state.messageType = 'error';
	    },
	    SENDING_PASS_RESET_LINK: function SENDING_PASS_RESET_LINK(state, payload) {
	      state.sendingPasswordResetLink = payload;
	    },
	    PASSWORD_RESET_LINK_SENT: function PASSWORD_RESET_LINK_SENT(state) {
	      state.sendingPasswordResetLink = false;
	      state.message = 'Reset link has been sent to your registered email.';
	    },
	    LOGOS_FETCHED: function LOGOS_FETCHED(state, payload) {
	      state.logos = payload;
	    }
	  },
	
	  actions: {
	    fetchConfig: function fetchConfig(_ref, payload) {
	      var _this = this;
	
	      var state = _ref.state;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
	        var config;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return (0, _authentication.getUserConfig)(payload.env, payload.client);
	
	              case 2:
	                config = _context.sent;
	                return _context.abrupt('return', config);
	
	              case 4:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this);
	      }))();
	    },
	    logout: function logout(_ref2) {
	      var state = _ref2.state;
	
	      (0, _authentication.signOut)().then(function () {
	        state.isAuthenticated = false;
	      });
	    },
	    fetchLogo: function fetchLogo(context) {
	      storageDb.database().ref('logos').once('value').then(function (snapshot) {
	        context.commit('LOGOS_FETCHED', snapshot.val());
	      });
	    },
	    sendResetLink: function sendResetLink(_ref3, username) {
	      var _this2 = this;
	
	      var state = _ref3.state,
	          commit = _ref3.commit,
	          rootState = _ref3.rootState;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee2() {
	        var env, config, normalized, email;
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                state.message = '';
	                commit('SENDING_PASS_RESET_LINK', true);
	                _context2.prev = 2;
	                env = rootState.appGlobal.env;
	                _context2.next = 6;
	                return (0, _authentication.getUserConfig)(env, username);
	
	              case 6:
	                config = _context2.sent;
	                normalized = (0, _config.normalizeConfig)(config.data);
	                email = config.data && config.data.firebase_email_id;
	
	                (0, _firebase5.initialise)(normalized);
	                (0, _authentication.sendPasswordResetEmail)(email).then(function () {
	                  (0, _firebase5.deleteApp)().then(function () {
	                    state.messageType = 'success';
	                    commit('PASSWORD_RESET_LINK_SENT');
	                  });
	                }).catch(function (error) {
	                  (0, _firebase5.deleteApp)().then(function () {
	                    commit('SENDING_PASS_RESET_LINK', false);
	                    commit('AUTH_FAILED', error);
	                  });
	                });
	                _context2.next = 17;
	                break;
	
	              case 13:
	                _context2.prev = 13;
	                _context2.t0 = _context2['catch'](2);
	
	                commit('SENDING_PASS_RESET_LINK', false);
	                commit('AUTH_FAILED', _context2.t0);
	
	              case 17:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this2, [[2, 13]]);
	      }))();
	    },
	    authenticate: function authenticate(_ref4, _ref5) {
	      var _this3 = this;
	
	      var state = _ref4.state,
	          commit = _ref4.commit,
	          rootState = _ref4.rootState;
	      var username = _ref5.username,
	          password = _ref5.password;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee3() {
	        var hostname, config, email, env, normalized;
	        return regeneratorRuntime.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                state.message = '';
	                hostname = window.location.hostname.split('.')[0];
	                config = void 0;
	                email = void 0;
	
	                commit('IS_AUTHENTICATING', true);
	                _context3.prev = 5;
	                env = rootState.appGlobal.env;
	
	                console.log(hostname !== 'insideinsight');
	
	                if (!(hostname !== 'insideinsight')) {
	                  _context3.next = 15;
	                  break;
	                }
	
	                _context3.next = 11;
	                return (0, _authentication.getUserConfig)(env, hostname);
	
	              case 11:
	                config = _context3.sent;
	
	                email = username;
	                _context3.next = 19;
	                break;
	
	              case 15:
	                _context3.next = 17;
	                return (0, _authentication.getUserConfig)(env, username);
	
	              case 17:
	                config = _context3.sent;
	
	                email = config.data && config.data.firebase_email_id;
	
	              case 19:
	                normalized = (0, _config.normalizeConfig)(config.data);
	
	                if (email) {
	                  _context3.next = 22;
	                  break;
	                }
	
	                throw Error('User not found');
	
	              case 22:
	                (0, _firebase5.initialise)(normalized);
	                (0, _authentication.signInWithEmail)(email, password).then(function (user) {
	                  localStorage.setItem(env, JSON.stringify(config.data));
	                  localStorage.setItem('firebase_email_id', email);
	                  localStorage.setItem('uid', user.uid);
	                  commit('SAVE_USER', user);
	                  commit('AUTH_SUCCESS');
	                  commit('CLEAR_MESSAGE');
	                }).catch(function (error) {
	                  (0, _firebase5.deleteApp)().then(function () {
	                    localStorage.clear();
	                    commit('IS_AUTHENTICATING', false);
	                    commit('AUTH_FAILED', error);
	                  });
	                });
	                _context3.next = 31;
	                break;
	
	              case 26:
	                _context3.prev = 26;
	                _context3.t0 = _context3['catch'](5);
	
	                localStorage.clear();
	                commit('IS_AUTHENTICATING', false);
	                commit('AUTH_FAILED', _context3.t0);
	
	              case 31:
	              case 'end':
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this3, [[5, 26]]);
	      }))();
	    },
	    anonymousAuthenticate: function anonymousAuthenticate(_ref6) {
	      var _this4 = this;
	
	      var state = _ref6.state,
	          commit = _ref6.commit,
	          rootState = _ref6.rootState;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
	        var env, config, normalized;
	        return regeneratorRuntime.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                state.message = '';
	                commit('IS_ANONYMOUS_AUTHENTICATING', true);
	                _context4.prev = 2;
	                env = rootState.appGlobal.env;
	                _context4.next = 6;
	                return (0, _authentication.getUserConfig)(env, window.location.hostname.split('.')[0]);
	
	              case 6:
	                config = _context4.sent;
	                normalized = (0, _config.normalizeConfig)(config.data);
	
	                (0, _firebase5.initialise)(normalized);
	                (0, _authentication.signInAnonymously)().then(function (user) {
	                  console.log(user.uid);
	                  localStorage.setItem(env, JSON.stringify(config.data));
	                  localStorage.setItem('uid', user.uid);
	                  localStorage.setItem('is_anonymous_login', true);
	                  _firebase2.default.database().ref('Users/' + user.uid).set({
	                    isAnonymousLogin: true
	                  });
	                  commit('SAVE_USER', user);
	                  commit('AUTH_SUCCESS');
	                  commit('CLEAR_MESSAGE');
	                }).catch(function (error) {
	                  (0, _firebase5.deleteApp)().then(function () {
	                    localStorage.clear();
	                    commit('IS_ANONYMOUS_AUTHENTICATING', false);
	                    commit('AUTH_FAILED', error);
	                  });
	                });
	                _context4.next = 17;
	                break;
	
	              case 12:
	                _context4.prev = 12;
	                _context4.t0 = _context4['catch'](2);
	
	                localStorage.clear();
	                commit('IS_ANONYMOUS_AUTHENTICATING', false);
	                commit('AUTH_FAILED', _context4.t0);
	
	              case 17:
	              case 'end':
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this4, [[2, 12]]);
	      }))();
	    },
	    googleAuthenticate: function googleAuthenticate(_ref7) {
	      var _this5 = this;
	
	      var state = _ref7.state,
	          commit = _ref7.commit,
	          rootState = _ref7.rootState;
	      return _asyncToGenerator(regeneratorRuntime.mark(function _callee5() {
	        var env, config, normalized;
	        return regeneratorRuntime.wrap(function _callee5$(_context5) {
	          while (1) {
	            switch (_context5.prev = _context5.next) {
	              case 0:
	                state.message = '';
	                _context5.prev = 1;
	                env = rootState.appGlobal.env;
	                _context5.next = 5;
	                return (0, _authentication.getUserConfig)(env, window.location.hostname.split('.')[0]);
	
	              case 5:
	                config = _context5.sent;
	                normalized = (0, _config.normalizeConfig)(config.data);
	
	                (0, _firebase5.initialise)(normalized);
	                (0, _authentication.signInWithGoogle)().then(function (response) {
	                  localStorage.setItem(env, JSON.stringify(config.data));
	                  localStorage.setItem('uid', response.user.uid);
	                  localStorage.setItem('is_anonymous_login', true);
	                  _firebase2.default.database().ref('Users/' + response.user.uid).set({
	                    email: response.user.email,
	                    firstName: response.user.displayName,
	                    lastName: '',
	                    organisation: 'IA'
	                  });
	                  commit('SAVE_USER', response.user);
	                  commit('AUTH_SUCCESS');
	                  commit('CLEAR_MESSAGE');
	                }).catch(function (error) {
	                  (0, _firebase5.deleteApp)().then(function () {
	                    localStorage.clear();
	                    commit('AUTH_FAILED', error);
	                  });
	                });
	                _context5.next = 15;
	                break;
	
	              case 11:
	                _context5.prev = 11;
	                _context5.t0 = _context5['catch'](1);
	
	                localStorage.clear();
	                commit('AUTH_FAILED', _context5.t0);
	
	              case 15:
	              case 'end':
	                return _context5.stop();
	            }
	          }
	        }, _callee5, _this5, [[1, 11]]);
	      }))();
	    }
	  }
	};
	
	exports.default = authentication;

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var user = {
	  state: {
	    profile: {}
	  },
	
	  mutations: {
	    SAVE_USER: function SAVE_USER(state, payload) {
	      state.profile = payload;
	    }
	  },
	
	  getters: {
	    uid: function uid(state) {
	      return state.profile.uid;
	    },
	    fullname: function fullname() {
	      var defaultName = 'User';
	      return defaultName;
	    }
	  }
	};
	
	exports.default = user;

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(36);
	
	var _firebase = __webpack_require__(13);
	
	var _firebase2 = _interopRequireDefault(_firebase);
	
	var _authentication = __webpack_require__(57);
	
	var _firebase3 = __webpack_require__(102);
	
	var _config = __webpack_require__(72);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  data: function data() {
	    return {
	      directLoginLoading: false,
	      warningDialogVisible: false
	    };
	  },
	
	  computed: _extends({}, (0, _vuex.mapGetters)(['authRequested', 'authenticated', 'authFailed', 'env', 'config']), {
	    isDirectSurvey: function isDirectSurvey() {
	      return localStorage.getItem('directSurveyId');
	    }
	  }),
	  watch: {
	    authenticated: function authenticated(isAuthenticated) {
	      var _this = this;
	
	      var env = this.env;
	      if (!isAuthenticated) {
	        (0, _config.clearConfig)(env);
	        return (0, _firebase3.deleteApp)().then(function () {
	          if (_this.isDirectSurvey) {
	            _this.$router.replace('/home/user/thankuser');
	            localStorage.clear();
	          } else {
	            localStorage.clear();
	            _this.$router.replace('/');
	          }
	        });
	      }
	      if (isAuthenticated) {
	        this.authSuccess();
	        this.gotoHomePage();
	        this.directLoginLoading = false;
	      }
	      return 0;
	    },
	    authFailed: function authFailed(isAuthFailed) {
	      console.log(this.$router);
	      if (isAuthFailed) {
	        this.directLoginLoading = false;
	      }
	    }
	  },
	
	  methods: _extends({}, (0, _vuex.mapActions)(['anonymousAuthenticate']), {
	    fetchSurvey: function fetchSurvey(id) {
	      return _firebase2.default.database().ref('IA/Survey/' + id).once('value');
	    },
	    onBlurFunction: function onBlurFunction() {
	      var _this2 = this;
	
	      var surveyId = this.$route.params.id;
	      if (surveyId) {
	        this.fetchSurvey(surveyId).then(function (data) {
	          if (data.val().endTime) {
	            _this2.warningDialogVisible = true;
	          }
	        }).catch(function (error) {
	          console.log(error);
	        });
	      }
	    },
	    gotoHomePage: function gotoHomePage() {
	      var _$route = this.$route,
	          path = _$route.path,
	          params = _$route.params;
	      var username = params.username,
	          password = params.password;
	
	      var isOnLoginPage = path === '/';
	      var hasCredsInParams = username && password;
	      if (isOnLoginPage || hasCredsInParams) {
	        if (localStorage.getItem('directSurveyId')) {
	          this.$router.replace('/' + localStorage.getItem('directSurveyId'));
	        } else {
	          this.$router.replace('/home');
	        }
	      }
	    },
	    authSuccess: function authSuccess() {
	      var user = (0, _authentication.getCurrentUser)();
	      this.$store.commit('SAVE_USER', user);
	      this.$store.commit('AUTH_SUCCESS');
	    },
	    onAuthChange: function onAuthChange(user) {
	      this.$store.commit('AUTH_REQUESTED');
	      if (user) return this.authSuccess();
	      return 0;
	    },
	    onConfigFetch: function onConfigFetch() {
	      var config = this.config;
	      var env = this.env;
	      (0, _config.saveConfig)(env, config);
	      var configuration = (0, _config.normalizeConfig)(config);
	      (0, _firebase3.initialise)(configuration);
	      return (0, _authentication.onAuthChange)(this.onAuthChange.bind(this));
	    }
	  }),
	
	  created: function created() {
	    window.onblur = this.onBlurFunction;
	
	    this.$store.dispatch('getConfigFromLS');
	
	    if (localStorage.getItem('directSurveyId') && !localStorage.getItem('uid')) {
	      this.anonymousAuthenticate('direct');
	      this.$store.commit('AUTH_REQUESTED');
	      this.directLoginLoading = true;
	      return true;
	    }
	
	    if (this.config) return this.onConfigFetch();
	
	    this.$store.commit('AUTH_REQUESTED');
	    var redirectUrl = '/';
	
	    var hasParams = Object.keys(this.$route.params).length > 1;
	    if (hasParams) {
	      var _$route$params = this.$route.params,
	          username = _$route$params.username,
	          password = _$route$params.password;
	
	      redirectUrl = '/' + username + '/' + password;
	    }
	    return this.$router.replace(redirectUrl);
	  }
	};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _vuex = __webpack_require__(36);
	
	exports.default = {
	  name: 'app-form-login',
	
	  data: function data() {
	    return {
	      host: 'insideinsight',
	      labels: ['Username', 'Password'],
	      placeholders: ['Username', 'Password'],
	      username: '',
	      password: '',
	      forgotPassword: false
	    };
	  },
	
	
	  watch: {
	    $route: function $route() {
	      this.refreshCredentials();
	    },
	    forgotPassword: function forgotPassword() {
	      this.$store.commit('CLEAR_MESSAGE');
	    }
	  },
	
	  computed: _extends({}, (0, _vuex.mapState)({
	    isAuthenticating: function isAuthenticating(state) {
	      return state.authentication.isAuthenticating;
	    },
	    isAnonymousAuthenticating: function isAnonymousAuthenticating(state) {
	      return state.authentication.isAnonymousAuthenticating;
	    },
	    isSendingLink: function isSendingLink(state) {
	      return state.authentication.sendingPasswordResetLink;
	    },
	    message: function message(state) {
	      return state.authentication.message;
	    },
	    logos: function logos(state) {
	      return state.authentication.logos;
	    }
	  }), {
	    urlConfig: function urlConfig() {
	      return window.location.hostname.split('.').length > 1;
	    }
	  }),
	
	  methods: _extends({}, (0, _vuex.mapActions)(['authenticate', 'sendResetLink', 'fetchLogo', 'anonymousAuthenticate', 'googleAuthenticate']), {
	    refreshCredentials: function refreshCredentials() {
	      var _$route$params = this.$route.params,
	          username = _$route$params.username,
	          password = _$route$params.password;
	
	      this.username = username || '';
	      this.password = password || '';
	    },
	    updateForm: function updateForm(host) {
	      if (host === 'staples') {
	        this.placeholders = ['print.marketingxxxx@staples.com', 'print.marketingxxxx@staples.com'];
	        this.labels = ['Email', 'Confirm your email'];
	        this.username = 'print.marketingxxxx@staples.com';
	      }
	    }
	  }),
	  created: function created() {
	    this.host = window.location.hostname.split('.')[0];
	    this.updateForm(this.host);
	    this.fetchLogo();
	    this.refreshCredentials();
	  }
	};

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'appHeader',
	  methods: {
	    handleSelect: function handleSelect(key) {
	      if (key === '/') {
	        this.$store.dispatch('logout');
	      }
	    }
	  },
	  computed: {
	    isAnonymousLogin: function isAnonymousLogin() {
	      return localStorage.getItem('is_anonymous_login');
	    },
	    isDirectSurvey: function isDirectSurvey() {
	      if (localStorage.getItem('directSurveyId')) {
	        return localStorage.getItem('directSurveyId').length > 0;
	      }
	      return false;
	    },
	    isForRecruitment: function isForRecruitment() {
	      return window.location.hostname.split('.')[0] === 'recruitment';
	    }
	  }
	};

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vuex = __webpack_require__(36);
	
	var _Header = __webpack_require__(468);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app-layout',
	  components: {
	    appHeader: _Header2.default
	  },
	  computed: (0, _vuex.mapGetters)(['authenticated'])
	};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _LoginForm = __webpack_require__(467);
	
	var _LoginForm2 = _interopRequireDefault(_LoginForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app-login',
	  components: {
	    appFormLogin: _LoginForm2.default
	  },
	  data: function data() {
	    return {
	      isDirectLogin: localStorage.getItem('directSurveyId') && localStorage.getItem('directSurveyId').length > 0
	    };
	  }
	};

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 451:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAcRJREFUOI2d1b1rFUEUBfDf2wipxAT/AyFGScRSCy1S+NFoF5AUogixs0v93tgGG7tYWInNs4qVFn5CgikfCqKghX+ASROjCNdi58U17q7PHJjm3jPn3Lk7e6cTEVpwDAuYwywmcnwTb/EcD1NK75sEOg0GR7GMy23uFaxiKaX0YRSDRdzF+IjiQ3zHrZTSvWqw2EPqYWUf4vKelW6326sGqydYzOJNeKPsOeU3OdXCvbl7kogQEVMRsRP12I6I+cyrrvmcq8NOREz1er3dFi1rbssN9Gvi/Zyrw3jWJCKmG6qIiNioqXzv2mjZP10o73kTHrXkRuEsFMoP1oRPIxi0ceYK5R/ahFGuaxtntsBkC+H0CAZtnMlOtA+jrziinD11mMBnv2fUXyiw1VYB7mOsJjeWc43i2BQR6y3XbIiXEXEmIoq8zubYv7Be4EWN8zfcwXFcxQxeYyfnXikvx3Wcx+OGEzzrRMQJDCrBNVzBl0rsEC5l0Y7yLVjFVkoJdLvdi3iAw5V9J4fD7kmuZA3nsN3S1z8wNMgmM1jHQTxNKV0YzqIl/MC1/xGvMXuH2/iZNR3IuYHy9fq4X/EK+oiU0gB+AWuhbNMExE9OAAAAAElFTkSuQmCC"

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 466:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(449)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(167),
	  /* template */
	  __webpack_require__(499),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(430)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(168),
	  /* template */
	  __webpack_require__(480),
	  /* scopeId */
	  "data-v-07c210c0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(455)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(170),
	  /* template */
	  __webpack_require__(503),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(426)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(173),
	  /* template */
	  __webpack_require__(477),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(450)
	__webpack_require__(451)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(175),
	  /* template */
	  __webpack_require__(500),
	  /* scopeId */
	  "data-v-c549f2d4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 477:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.authenticated) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-row', {
	    staticClass: "login-form"
	  }, [_c('el-col', [_c('img', {
	    staticClass: "ii-logo",
	    attrs: {
	      "src": "/static/ii_logo.png"
	    }
	  }), _vm._v(" "), _c('el-card', {
	    staticClass: "login_card"
	  }, [_c('img', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.logos),
	      expression: "logos"
	    }],
	    staticClass: "client-logo",
	    attrs: {
	      "src": _vm.logos[_vm.host] || _vm.logos['insideinsight']
	    }
	  }), _vm._v(" "), (_vm.message) ? _c('el-alert', {
	    attrs: {
	      "title": _vm.message,
	      "type": "error",
	      "showicon": "",
	      "closable": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('el-form', {
	    attrs: {
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": _vm.labels[0]
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": _vm.placeholders[0]
	    },
	    model: {
	      value: (_vm.username),
	      callback: function($$v) {
	        _vm.username = $$v
	      },
	      expression: "username"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.forgotPassword),
	      expression: "!forgotPassword"
	    }],
	    attrs: {
	      "label": _vm.labels[1]
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "type": _vm.host === 'staples' ? 'text' : 'password',
	      "placeholder": _vm.placeholders[1]
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1), _vm._v(" "), (_vm.host === 'staples') ? _c('span', {
	    attrs: {
	      "id": "hint"
	    }
	  }, [_vm._v("Replace xxxx with your Store ID")]) : _vm._e(), _vm._v(" "), _c('el-form-item', [(_vm.host !== 'staples') ? _c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.forgotPassword),
	      expression: "!forgotPassword"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    on: {
	      "click": function($event) {
	        _vm.forgotPassword = true
	      }
	    }
	  }, [_vm._v("\n            Forgot password? Click Here\n          ")]) : _vm._e(), _vm._v(" "), _c('el-button', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.forgotPassword),
	      expression: "forgotPassword"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    on: {
	      "click": function($event) {
	        _vm.forgotPassword = false
	      }
	    }
	  }, [_vm._v("\n            Return to login\n          ")])], 1), _vm._v(" "), _c('el-form-item', [(!_vm.forgotPassword) ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.isAuthenticating
	    },
	    on: {
	      "click": function($event) {
	        _vm.authenticate({
	          username: _vm.username,
	          password: _vm.password
	        })
	      }
	    }
	  }, [_vm._v("\n            Sign In\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.forgotPassword && _vm.urlConfig) ? _c('div', [_c('div', [_vm._v("OR")]), _vm._v(" "), _c('el-button', {
	    staticStyle: {
	      "padding": "0"
	    },
	    on: {
	      "click": _vm.googleAuthenticate
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/G-SIGN.png",
	      "id": "dagger",
	      "height": "50px"
	    }
	  })]), _vm._v(" "), _c('el-button', {
	    attrs: {
	      "loading": _vm.isAnonymousAuthenticating
	    },
	    on: {
	      "click": function($event) {
	        _vm.anonymousAuthenticate()
	      }
	    }
	  }, [_vm._v("\n              Sign In As Guest\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.forgotPassword) ? _c('el-button', {
	    attrs: {
	      "type": "primary",
	      "loading": _vm.isSendingLink
	    },
	    on: {
	      "click": function($event) {
	        _vm.sendResetLink(_vm.username)
	      }
	    }
	  }, [_vm._v("\n              Send Reset Link\n          ")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 499:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading.fullscreen.lock",
	      value: (_vm.directLoginLoading),
	      expression: "directLoginLoading",
	      modifiers: {
	        "fullscreen": true,
	        "lock": true
	      }
	    }],
	    attrs: {
	      "id": "app"
	    }
	  }, [(_vm.authRequested) ? _c('div', {
	    attrs: {
	      "id": "router-mount"
	    }
	  }, [_c('router-view')], 1) : _vm._e(), _vm._v(" "), _c('el-dialog', {
	    attrs: {
	      "title": "Alert",
	      "visible": _vm.warningDialogVisible,
	      "width": "40%",
	      "close-on-click-modal": false,
	      "show-close": false,
	      "close-on-press-escape": false,
	      "center": ""
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.warningDialogVisible = $event
	      }
	    }
	  }, [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s("<p>This is a warning message. To continue the test, please call Impact Analytics team.</p><p><span style='color: #ff0000;'><strong>Warning:</strong>&nbsp;Your activity is being tracked.</span></p>")
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "plain": ""
	    },
	    on: {
	      "click": function($event) {
	        _vm.warningDialogVisible = false
	      }
	    }
	  }, [_vm._v("Okay")])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isDirectLogin) ? _c('div', {
	    attrs: {
	      "id": "app-login"
	    }
	  }, [_c('app-form-login')], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "header-container"
	  }, [_c('el-menu', {
	    staticClass: "gradient",
	    attrs: {
	      "default-active": "1",
	      "mode": "horizontal",
	      "router": ""
	    },
	    on: {
	      "select": _vm.handleSelect
	    }
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(465)
	    }
	  }), _vm._v(" "), (!_vm.isDirectSurvey) ? _c('el-submenu', {
	    staticClass: "item-right profile-image",
	    attrs: {
	      "index": ""
	    }
	  }, [_c('template', {
	    slot: "title"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(464)
	    }
	  })]), _vm._v(" "), (!_vm.isAnonymousLogin && !_vm.isForRecruitment) ? _c('el-menu-item', {
	    attrs: {
	      "index": "/home/user/resetPassword"
	    }
	  }, [_vm._v("Reset Password")]) : _vm._e(), _vm._v(" "), _c('el-menu-item', {
	    attrs: {
	      "index": "/"
	    }
	  }, [_vm._v("Logout")])], 2) : _vm._e(), _vm._v(" "), (!_vm.isDirectSurvey && !_vm.isForRecruitment) ? _c('el-menu-item', {
	    staticClass: "item-right",
	    attrs: {
	      "index": "/home"
	    }
	  }, [_vm._v("Home")]) : _vm._e()], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 508:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.b3588dfa8425e26949f2.js